import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine, ResponsiveContainer,
} from 'recharts';
import { FACTOR_THRESHOLDS, FACTOR_COLORS, formatWeekLabel, formatFactor } from './chartUtils';
import type { BreakdownFactorTrend } from '~/common/api/zeiterfassungServerApi/ProjectRecordApi';
import useTranslate from '~/common/utils/translate';

interface Props {
  data: BreakdownFactorTrend[];
}

export const FactorTrendChart: React.FC<Props> = ({ data }) => {
  const t = useTranslate();
  const chartData = data.map((d) => ({
    label: formatWeekLabel(d.year, d.week),
    factor: d.avg_factor_calculated,
  }));

  return (
    <Box bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="lg" p={3}>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        {t('projectRecords.chart.factorTrend')}
      </Text>
      <Box h="200px">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <XAxis dataKey="label" tick={{ fontSize: 10 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip formatter={(value) => formatFactor(value as number)} />
            <ReferenceLine
              y={FACTOR_THRESHOLDS.good} stroke={FACTOR_COLORS.good}
              strokeDasharray="4 4" label={{ value: '1.5x', position: 'right', fontSize: 10 }}
            />
            <ReferenceLine
              y={FACTOR_THRESHOLDS.warning} stroke={FACTOR_COLORS.bad}
              strokeDasharray="4 4" label={{ value: '2.5x', position: 'right', fontSize: 10 }}
            />
            <Line type="monotone" dataKey="factor" stroke="#3182ce" strokeWidth={2} dot={{ r: 3 }} />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};
